<template>
  <div class="print-content">
    <div class="print-head">
      {{pageTitle}}
    </div>
    <div class="print-body">
      <div class="print-html">
        <div ref="PrintTable" v-html="tempHtml" class="table-wrap" :style="'width:' + eidtorWidth + 'px;padding:'+ marginTop +'px '+ marginRight +'px '+ marginBottom +'px '+ marginLeft +'px'"></div>
        <div ref="truethPrintTable" v-html="truethTempHtml" class="table-wrap trueth-print" :style="'width:' + eidtorWidth + 'px;padding:'+ marginTop +'px '+ marginRight +'px '+ marginBottom +'px '+ marginLeft +'px'"></div> <!-- 真正打印的内容 -->
      </div>
      <div class="print-btn">
        <el-button @click="cancel">关闭</el-button>
        <el-button type="primary" @click="print">打印</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import assignmentManage from '@/store/assignmentManage/index'
import {GETTEMPLATEDATA, CANCELPRINTTEMP} from '@/store/assignmentManage/types'
import PrintTable from './PrintTable'
import {mmConversionPx} from '@/utils/unitConversion' /*  */
import {getChaKey} from '@/utils/getPrintTempKey'
import {CLOSECURRENTTAG} from '../../store/user/types'
let productTable = /<table((?!table)[\s\S])*\$商品索引\$((?!table)[\s\S])*<\/table>/g
let productIndex = /<tr.((?!tr).)*<td((?!tr).)*\$商品索引\$((?!tr).)*<\/td>((?!tr).)*<\/tr>/g // 商品列表索引
let regtr = /<tr.*?<\/tr>/g
let shopSelected = /\$供应商店铺名称\$/g // 供应商店铺列表

export default {
  name: 'printtemp',
  data () {
    return {
      pageTitle: '',
      today: null,
      tempHtml: '',
      eidtorWidth: 1000, // 编辑器宽度
      marginTop: '', // 上边距
      marginRight: '', // 右边距
      marginBottom: '', // 下边距
      marginLeft: '', // 左边距
      truethTempHtml: ''
    }
  },
  components: {
    PrintTable
  },
  computed: {
    // 任务详情数据
    taskEdit () {
      return assignmentManage.state.taskEdit
    },
    // 商品列表
    taskPrintBillGoodList () {
      let list = []
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 3) {
        list = assignmentManage.state.taskPrintBillPutawayGoodList
      }
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 1) {
        // eslint-disable-next-line eqeqeq
        if (this.$route.params.nature == 2) {
          list = assignmentManage.state.taskPrintBillIntoGoodList
        } else {
          list = assignmentManage.state.taskPrintBillOutGoodList
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 2) {
        list = assignmentManage.state.taskPrintBillPickGoodList
      }
      return list
    },
    // 共计件数
    taskPrintBillGoodsTotalPiece () {
      let total = ''
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 3) {
        total = assignmentManage.state.taskPrintBillPutawayGoodsTotalPiece
      }
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 1) {
        // eslint-disable-next-line eqeqeq
        if (this.$route.params.nature == 2) {
          total = assignmentManage.state.taskPrintBillIntoGoodsTotalPiece
        } else {
          total = assignmentManage.state.taskPrintBillOutGoodsTotalPiece
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 2) {
        total = assignmentManage.state.taskPrintBillPickGoodsTotalPiece
      }
      return total
    },
    // SKU种数
    taskPrintBillGoodsSku () {
      let SKUnum = 0
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 3) {
        SKUnum = assignmentManage.state.taskPrintBillPutawayGoodsSku
      }
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 1) {
        // eslint-disable-next-line eqeqeq
        if (this.$route.params.nature == 2) {
          SKUnum = assignmentManage.state.taskPrintBillIntoGoodsSku
        } else {
          SKUnum = assignmentManage.state.taskPrintBillOutGoodsSku
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.mode == 2) {
        SKUnum = assignmentManage.state.taskPrintBillPickGoodsSku
      }
      return SKUnum
    },
    // 模板数据
    tempData () {
      console.log(assignmentManage.state.printTemplateData);
      
      return assignmentManage.state.printTemplateData
    },
    // 标识
    constMark () {
      return assignmentManage.state.constMark
    }
  },
  watch: {
    taskPrintBillGoodList: {
      deep: true,
      handler (val) {
        console.log(val)
        setTimeout(() => {
          this.initTable()
        }, 300)
      },
      immediate: true
    },
    constMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          assignmentManage.state.constMark = 0
          let path = ''
          let name = ''
          // eslint-disable-next-line eqeqeq
          if (this.$route.params.mode == 3) {
            path = '/rollsHomework/putawayList/putawayListDetail/' + this.$route.params.code
            name = 'putawayListDetail'
            this.$store.dispatch(CLOSECURRENTTAG, {path, name})
          } else {
            // eslint-disable-next-line eqeqeq
            if (this.$route.params.nature == 2) {
              if (this.taskEdit.status === 2) {
                path = '/assignmentManage/warehouseIntoEdit/' + this.taskEdit.code + '/' + this.$route.params.nature + '/' + this.taskEdit.taskType
                name = 'assignmentedit'
              } else if (this.taskEdit.status === 3) {
                path = '/assignmentManage/warehouseIntoDetail/' + this.taskEdit.code + '/2'
                name = 'warehouseIntoDetail'
              }
            } else {
              console.log(this.taskEdit.status)
              if (this.taskEdit.status === 3) {
                path = '/assignmentManage/warehouseOutDetail/' + this.taskEdit.code + '/1'
                name = 'warehouseOutDetail'
              } else {
                path = '/assignmentManage/warehouseOutEdit/' + this.taskEdit.code + '/' + this.$route.params.nature
                name = 'warehousequtedit'
              }
            }
            this.$store.dispatch(CLOSECURRENTTAG, {path, name})
          }

          // this.$router.push('/assignmentmanage/assignmentmanage')
        }
      }
    }
  },
  mounted () {
    this.getToDay()
    // this.initTable()
  },
  created () {
    // eslint-disable-next-line eqeqeq
    if (this.$route.params.mode == 3) {
      this.pageTitle = '打印上架单'
    // eslint-disable-next-line eqeqeq
    } else if (this.$route.params.mode == 1) {
      // eslint-disable-next-line eqeqeq
      if (this.$route.params.nature == 2) {
        this.pageTitle = '打印入库单'
      } else {
        this.pageTitle = '打印出库单'
      }
    } else {
      this.pageTitle = '打印拣货单'
    }
  },
  methods: {
    setTableHead (html) {
      let tablearr = []
      let tmeparr = []
      let fragment = ''
      html.replace(productTable, function (str) {
        tablearr.push(str)
      })
      if (tablearr.length) {
        let arr = []
        for (let i = 0; i < tablearr.length; i++) {
          if (arr.length) {
            arr = arr.concat(arr[i].split(tablearr[i]))
            arr.splice(i, 1)
          } else {
            arr = html.split(tablearr[i])
          }
        }
        for (let j = 0; j < arr.length - 1; j++) {
          tmeparr.push(arr[j])
          tmeparr.push(tablearr[j])
        }
        tmeparr.push(arr[arr.length - 1])
      }
      tmeparr.forEach(x => {
        if (x && (x.indexOf('$商品索引$') !== -1)) {
          let trList = []
          x.replace(regtr, function (str) {
            trList.push(str)
          })
          let thead = '<thead>'
          let tbody = ''
          let tfoot = '<tfoot>'
          let j = 0
          for (let i = 0; i < trList.length; i++) {
            if (productIndex.test(trList[i])) {
              thead += '</thead>'
              tbody = '<tbody>' + trList[i] + '</tbody>'
              j = i
            } else {
              if (j === 0) {
                thead += trList[i]
              } else if (j < i) {
                tfoot += trList[i]
              }
            }
          }
          tfoot += '</tfoot>'
          fragment += '<table>' + thead + tbody + tfoot + '</table>'
        } else {
          fragment += x
        }
      })
      return fragment
    },
    initTable () {
      let that = this
      let params = { code: this.$route.params.code, mode: this.$route.params.mode }
      that.$store.dispatch(GETTEMPLATEDATA, params).then((res) => {
        if (res) {
          res.goodsTotalPiece = that.taskPrintBillGoodsTotalPiece
          res.goodsSku = that.taskPrintBillGoodsSku
          if (!res.ydppName) {
            res.ydppName = '--'
          }
          if (!res.taskCode) {
            res.taskCode = '-'
          }
          that.eidtorWidth = mmConversionPx(res.yptWh.split(',')[0]) // 编辑器宽度
          let trbl = res.yptMargins.split(',') // 获取边距数组
          that.marginTop = mmConversionPx(trbl[0])
          that.marginRight = mmConversionPx(trbl[3])
          that.marginBottom = mmConversionPx(trbl[1])
          that.marginLeft = mmConversionPx(trbl[2])
          let template = res.yptContent // 模板html that.setTableHead()
          that.taskPrintBillGoodList.forEach(x => {
            x.actualNum = x.actualNum || 0
            x.actualWornNum = x.actualWornNum || 0
            x.goodsTotalNumTwo = parseInt((x.actualWornNum + x.actualNum) / x.box) + '+' + ((x.actualWornNum + x.actualNum) % x.box)
            x.goodsTotalNumOne = x.actualWornNum + x.actualNum
          })
          let goodsList = that.taskPrintBillGoodList // 商品信息列表
          let shopList = res.supplierShopName ? res.supplierShopName.split(',') : []
          let fragment = ''
          let tmeparr = [] // 总的模版
          let tempforarr = [] // 用 replace 处理 得到 字段中需要循环的模版
          template.replace(productIndex, function (str) {
            tempforarr.push(str)
          })
          if (tempforarr.length) {
            let arr = []
            let splitTemp = [] // 已经切过的模板
            for (let i = 0; i < tempforarr.length; i++) {
              if (arr.length) {
                if (!(splitTemp.some(x => x === tempforarr[i]))) {
                  arr = arr.concat(arr[i].split(tempforarr[i]))
                  arr.splice(i, 1)
                  splitTemp.push(tempforarr[i])
                }
              } else {
                arr = template.split(tempforarr[i])
                splitTemp.push(tempforarr[i])
              }
            }
            for (let j = 0; j < arr.length - 1; j++) {
              tmeparr.push(arr[j])
              tmeparr.push(tempforarr[j])
            }
            tmeparr.push(arr[arr.length - 1])
          }
          // 处理模版
          for (var m = 0; m < tmeparr.length; m++) {
            if ((tmeparr[m] && tmeparr[m].indexOf('$商品索引$') !== -1)) {
              let forTempCont = ''
              let forTempHtml = tmeparr[m]
              // if (shopSelected.test(tmeparr[m]) && tmeparr[m].search('供应商店铺名称') !== -1) {
              //   let reg = new RegExp(/\$供应商店铺名称\$/, 'ig')
              //   if (shopList.length) {
              //     let html = '<select class="storeSelect" placeholder="请选择">'
              //     shopList.forEach((x) => {
              //       html += '<option >' + x + '</option>'
              //     })
              //     html += '</select>'
              //     tmeparr[m] = tmeparr[m].replace(reg, html)
              //   } else {
              //     tmeparr[m] = tmeparr[m].replace(reg, '')
              //   }
              // }
              // 将循环体的模版 与 数据结合得到 相应的 html结构
              for (let n = 0; n < goodsList.length; n++) {
                forTempCont += that.forReplace(forTempHtml, goodsList[n], (n + 1))
              }
              // 得到循环后的html结构 将此结构 替换 原先的模版
              forTempCont = that.strReplace(forTempCont, res)
              fragment += tmeparr[m].replace(regtr, forTempCont)
            } else {
              if (shopSelected.test(tmeparr[m]) && tmeparr[m].search('供应商店铺名称') !== -1) {
                let reg = new RegExp(/\$供应商店铺名称\$/, 'ig')
                if (shopList.length) {
                  let html = '<select class="storeSelect" placeholder="请选择">'
                  shopList.forEach((x) => {
                    html += '<option >' + x + '</option>'
                  })
                  html += '</select>'
                  tmeparr[m] = tmeparr[m].replace(reg, html)
                } else {
                  tmeparr[m] = tmeparr[m].replace(reg, '')
                }
              }
              let regVal = /\$.+?\$/g
              if (regVal.test(tmeparr[m])) {
                let html = tmeparr[m]
                fragment += that.strReplace(html, res)
              } else {
                fragment += tmeparr[m]
              }
            }
          }
          that.tempHtml = fragment
        }
      })
    },
    strReplace (temps, obj) {
      let mode = this.$route.params.mode
      var t, key, reg
      for (key in obj) {
        reg = new RegExp(getChaKey(key, mode), 'ig')
        if (obj[key] || obj[key] === 0) {
          if (getChaKey(key, mode)) t = (t || temps).replace(reg, obj[key])
        } else {
          t = (t || temps).replace(reg, '')
        }
      }
      return t
    },
    forReplace (temps, obj, idx) {
      let mode = this.$route.params.mode
      var t, key, reg, testReg
      for (key in obj) {
        testReg = getChaKey(key, mode)
        if (testReg && testReg.test(t || temps)) {
          reg = new RegExp(getChaKey(key, mode), 'ig')
          if (obj[key] || obj[key] === 0) {
            t = (t || temps).replace(reg, obj[key])
          } else {
            t = (t || temps).replace(reg, '')
          }
        }
      }
      t = (t || temps).replace('$商品索引$', idx)
      return t
    },
    getToDay () {
      let now = new Date()
      let nowYear = now.getFullYear()
      let nowMonth = now.getMonth()
      let nowDate = now.getDate()
      nowMonth = this.doHandleMonth(nowMonth + 1)
      nowDate = this.doHandleMonth(nowDate)
      this.today = nowYear + '-' + nowMonth + '-' + nowDate
    },
    doHandleMonth (month) {
      if (month.toString().length === 1) {
        month = '0' + month
      }
      return month
    },
    // 打印
    print (e) {
      // console.log(this.$print, 'this.$print'
      let storeSelectValue = document.querySelectorAll('.storeSelect')
      // storeSelectValue.map((x) => { return x.value })
      // [].map.call(storeSelectValue, (x) => { return x.value })
      let storeList = []
      for (let i = 0; i < storeSelectValue.length; i++) {
        storeList.push(storeSelectValue[i].value)
      }
      let html = ''
      if (storeList.length) {
        storeList.forEach(x => {
        // <table((?!table)[\s\S])*\$商品索引\$((?!table)[\s\S])*<\/table> /<select class="storeSelect" placeholder="请选择">.*?<\/select>/ig /<select((?!select)[\s\S])*加多宝鳌峰店((?!select)[\s\S])*<\/select>/
          let reg = /<select class="storeSelect" placeholder="请选择">.*?<\/select>/ig // new RegExp('<select((?!select)[\\s\\S])*' + x + '((?!select)[\\s\\S])*<\\/select>', 'ig')
          html = this.tempHtml.replace(reg, x)
        })
        this.truethTempHtml = html
      } else {
        this.truethTempHtml = this.tempHtml
      }
      this.$nextTick(() => {
        this.$print(this.$refs.truethPrintTable)
      })
    },
    cancel () {
      this.$store.dispatch(CANCELPRINTTEMP)
    }
  }
}
</script>
<style>
@media print{
  .trueth-print {
    visibility: visible !important;
    right: 0 !important;
  }
  /* table {
    page-break-inside: avoid;
  } */
  .table-wrap table{table-layout: fixed;}
  .table-wrap table {
    margin-bottom: 10px;
    border-collapse: collapse;
    display: table;
  }
  .table-wrap table tbody, .table-wrap table thead {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }
  .table-wrap table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
  }
  .table-wrap table td, .table-wrap table th {
    padding: 7px 10px;
    border: 1px solid #000;
    display: table-cell;
    word-break: break-all;
    word-wrap:break-word;
  }

  .table-wrap select {
    border-color: transparent !important;
  }
}
.table-wrap table {
  margin-bottom: 10px;
  border-collapse: collapse;
  display: table;
}
.table-wrap table tbody, .table-wrap table thead {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}
.table-wrap table tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}
.table-wrap table td, .table-wrap table th {
  padding: 7px 10px;
  border: 1px solid #000;
  display: table-cell;
}

.table-wrap select {
  border-color: transparent !important;
}
</style>
<style scope>
.table-wrap table{table-layout: fixed;}
.table-wrap table td, .table-wrap table th {
    word-break: break-all;
    word-wrap:break-word;
  }
  .trueth-print {
    position: absolute;
    right: -100%;
    top: 0;
    visibility: hidden;
  }
  .print-head {
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border: 1px solid #EBEEF5;
    background-color: #fff;
    border-radius: 4px;
    height: 50px;
    padding-left: 20px;
    line-height: 50px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .print-content {
    position: fixed;
    top: 139px;
    left: 257px;
    background: #f0f0f0;
    bottom: 7px;
    right: 7px;
    box-sizing: border-box;
    overflow:hidden;
  }
  .print-body {
    height: calc(100% - 60px);
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .print-html{
    height: calc(100% - 50px);
    overflow:auto;
  }
  .table-wrap {
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
  }
  .print-content .print-btn {
    background: #fff;
    position: absolute;
    bottom: 0;
    height: 50px;
    left: 0;
    right: 0;
    border-top: 1px solid #e9e9e9;
    display:flex;
    align-items: center;
    justify-content: center;
     z-index: 99999,
  }
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/PrintTemp.vue